import { Chrome } from "lucide-react";
import { storeUrl } from "../lib/links";
import { home } from "../content/home";
import { HeroFilm } from "./HeroFilm";
import { SoundWaveEdge } from "./SoundWaveEdge";

const { headline, sub, cta, secondary, micro } = home.hero;

const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-paper";

export function HeroSection() {
  return (
    // The grid is the hero's alone. It slides up under the sticky nav (72px) so the nav sits on grid paper too.
    <section className="-mt-[72px] bg-paper bg-grid-paper bg-grid pt-[72px]">
      <div className="px-4 pb-8 pt-10 sm:px-6 lg:pb-12 lg:pt-16">
        <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:gap-12">
          <div>
            <h1 className="font-serif text-[clamp(2.4rem,4vw,3.3rem)] font-medium leading-[0.95] tracking-[-0.02em] text-char">
              {headline.line1}
              <br />
              <em className="text-brand-500">{headline.line2}</em>
            </h1>

            <div className="mt-7">
              <p className="max-w-[34rem] font-sans text-lg leading-relaxed text-char/80">
                {sub}
              </p>

              <div className="mt-9 flex flex-wrap items-center gap-4">
                <a
                  href={storeUrl("hero")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`inline-flex h-12 items-center gap-2 rounded-[12px] border border-char bg-brand-600 px-6 font-sans text-[15px] font-semibold text-white shadow-offset transition-[transform,box-shadow] duration-150 hover:-translate-x-0.5 hover:translate-y-0.5 hover:shadow-[-3px_4px_0_0_#262524] active:-translate-x-[5px] active:translate-y-[6px] active:shadow-none ${focusRing}`}
                >
                  <Chrome className="h-4 w-4" aria-hidden="true" />
                  {cta}
                </a>
                <a
                  href="#how-it-works"
                  className={`rounded font-sans text-[15px] font-semibold text-char underline decoration-char/30 underline-offset-[6px] transition-colors hover:decoration-char ${focusRing}`}
                >
                  {secondary}
                </a>
              </div>

              <p className="mt-6 flex items-center gap-2 font-hand text-[22px] text-char/75">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 48 20"
                  className="h-5 w-12 text-char/60"
                  fill="none"
                >
                  <path
                    d="M2 4c8 10 22 13 38 8m0 0-6-6m6 6-7 4"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {micro}
              </p>
            </div>
          </div>

          <HeroFilm />
        </div>
      </div>
      <SoundWaveEdge />
    </section>
  );
}
